// Các hàm dựng hiệu ứng trên canvas.
//
// Điểm quan trọng về hiệu năng: drawCanvas() chạy lại mỗi lần mousemove khi
// người dùng kéo ảnh, trên canvas 1200x3000. Nếu áp ctx.filter trực tiếp mỗi
// khung hình thì sẽ giật rất nặng. Vì vậy ảnh đã lọc được render một lần ra
// canvas ngoài màn hình rồi cache lại; lúc kéo chỉ còn drawImage bitmap có sẵn.

import { supportsCanvasFilter } from "../constants/filters";

const GRAIN_TILE = 256;

let grainTile = null;

// Ảnh nhiễu chỉ sinh một lần cho cả vòng đời trang, không sinh lại mỗi khung hình.
const getGrainTile = () => {
    if (grainTile) return grainTile;

    const tile = document.createElement("canvas");
    tile.width = GRAIN_TILE;
    tile.height = GRAIN_TILE;

    const ctx = tile.getContext("2d");
    const data = ctx.createImageData(GRAIN_TILE, GRAIN_TILE);

    for (let i = 0; i < data.data.length; i += 4) {
        // Lệch quanh mức xám 128 để chế độ hoà trộn "overlay" giữ nguyên độ sáng gốc.
        const v = 128 + (Math.random() - 0.5) * 255;
        data.data[i] = v;
        data.data[i + 1] = v;
        data.data[i + 2] = v;
        data.data[i + 3] = 255;
    }

    ctx.putImageData(data, 0, 0);
    grainTile = tile;
    return tile;
};

// Dựng sẵn bản đã lọc của một ảnh, ở đúng độ phân giải gốc.
export const renderFilteredBitmap = (img, filter) => {
    const out = document.createElement("canvas");
    out.width = img.width;
    out.height = img.height;

    const ctx = out.getContext("2d");

    if (filter.css && filter.css !== "none" && supportsCanvasFilter) {
        ctx.filter = filter.css;
    }
    ctx.drawImage(img, 0, 0);
    ctx.filter = "none";

    if (filter.bloom && supportsCanvasFilter) {
        // Bản làm mờ chồng lên theo chế độ "screen" tạo quầng sáng mềm.
        const blurred = document.createElement("canvas");
        blurred.width = out.width;
        blurred.height = out.height;

        const bctx = blurred.getContext("2d");
        bctx.filter = `blur(${Math.round(out.width * 0.012)}px)`;
        bctx.drawImage(out, 0, 0);

        ctx.save();
        ctx.globalCompositeOperation = "screen";
        ctx.globalAlpha = filter.bloom;
        ctx.drawImage(blurred, 0, 0);
        ctx.restore();
    }

    return out;
};

// Bốn góc tối dần. Gọi khi ctx đã clip vào vùng ô ảnh.
export const drawVignette = (ctx, slot, strength) => {
    const cx = slot.x + slot.w / 2;
    const cy = slot.y + slot.h / 2;
    const outer = Math.max(slot.w, slot.h) * 0.75;

    const g = ctx.createRadialGradient(cx, cy, outer * 0.45, cx, cy, outer);
    g.addColorStop(0, "rgba(0, 0, 0, 0)");
    g.addColorStop(1, `rgba(0, 0, 0, ${strength})`);

    ctx.save();
    ctx.fillStyle = g;
    ctx.fillRect(slot.x, slot.y, slot.w, slot.h);
    ctx.restore();
};

// Hạt film. Gọi khi ctx đã clip vào vùng ô ảnh.
export const drawGrain = (ctx, slot, strength) => {
    const pattern = ctx.createPattern(getGrainTile(), "repeat");
    if (!pattern) return;

    ctx.save();
    ctx.globalCompositeOperation = "overlay";
    ctx.globalAlpha = strength;
    ctx.fillStyle = pattern;
    ctx.fillRect(slot.x, slot.y, slot.w, slot.h);
    ctx.restore();
};

// Lớp màu phẳng làm bạc màu ảnh. Gọi khi ctx đã clip vào vùng ô ảnh.
export const drawWash = (ctx, slot, color) => {
    ctx.save();
    ctx.fillStyle = color;
    ctx.fillRect(slot.x, slot.y, slot.w, slot.h);
    ctx.restore();
};

// Phủ đủ khung ô ảnh, giữ nguyên tỉ lệ, phần thừa bị cắt (giống object-fit: cover).
export const coverTransform = (img, slot) => {
    const scale = Math.max(slot.w / img.width, slot.h / img.height);
    return {
        scale,
        offsetX: (slot.w - img.width * scale) / 2,
        offsetY: (slot.h - img.height * scale) / 2
    };
};
